module.exports = __webpack_public_path__ + "img/pn.pn353f8e6.svg";